import { SVGIconProps } from "@faire/slate-icons/types";
import { isNotUndefined } from "@faire/typescript";
import React from "react";

type IProps = Omit<React.HtmlHTMLAttributes<HTMLDivElement>, "className"> & {
  Icon: React.FC<SVGIconProps>;
  fontSize?: string;
  titleAccess?: string;
  // Force className to be provided
  className: string;
};

export const ButtonIcon: React.FC<IProps> = ({
  titleAccess,
  Icon,
  className,
  fontSize,
  ...props
}) => (
  <div {...props} className={className}>
    <Icon
      color="inherit"
      {...(isNotUndefined(titleAccess) ? { titleAccess } : {})}
    />
  </div>
);
